import { FormattedMessage } from "react-intl";

import {
    LayoutVersion,
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { SubHeading, WelcomeBackHeading } from "../../components";

export const ExistingUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    let content = (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            <WelcomeBackHeading />
            <SubHeading>
                <FormattedMessage
                    id="signup.teamworkCollection.subHeading"
                    defaultMessage="It’s free for up to 10 users - no credit card needed."
                />
            </SubHeading>
            <SiteActivation />
        </SignupBackgroundLayout>
    );

    if (twcSignupOverlayEnrolled) {
        content = (
            <TwcOverlayTemplate
                size="sm"
                version={LayoutVersion.V4}
                productLogo={<TeamworkCollectionLogo shouldShowBrand={false} />}
            >
                <WelcomeBackHeading />
                <SubHeading>
                    <FormattedMessage
                        id="signup.teamworkCollection.subHeading"
                        defaultMessage="It’s free for up to 10 users - no credit card needed."
                    />
                </SubHeading>
                <SiteActivation />
            </TwcOverlayTemplate>
        );
    }

    return content;
};
